export default __webpack_public_path__ + "static/media/storytel.9b2b7fb8.jpg";